module.exports = __webpack_public_path__ + "assets/img/29_1135.eb083c1e.jpg";